import React from 'react';
import { withRouter, Switch, Redirect } from 'react-router';

import { ROUTES } from 'configs/routes/constants';
import { redirectToExternalLogin } from 'helpers/Location';
import { COMMON_ROUTES, PUBLIC_ROUTES } from 'modules/app/routes';
import PropTypes from 'prop-types';

import { renderRoutes } from './helper';

const routes = renderRoutes([...COMMON_ROUTES, ...PUBLIC_ROUTES]);

const External = ({ location }) => {
  redirectToExternalLogin(location);

  return (
    <Switch>
      {routes}
      <Redirect to={ROUTES.LOGIN} />
    </Switch>
  );
};

External.propTypes = {
  location: PropTypes.object
};

const hocExternal = withRouter(External);

export default hocExternal;
